import React from 'react';
import { Box } from '@skin-seoul/design-system';
import { LoyaltyBannerDesktop } from './LoyaltyBanner.Desktop';
import { LoyaltyBannerMobile } from './LoyaltyBanner.Mobile';
interface LoyaltyBannerProps {
  points: number;
  memberSince?: string;
}
export const LoyaltyBanner = ({
  points,
  memberSince
}: LoyaltyBannerProps) => {
  return <>
      {/* Mobile View - Below tablet breakpoint (768px) */}
      <Box hideFrom="tablet" data-sentry-element="Box" data-sentry-source-file="LoyaltyBanner.tsx">
        <LoyaltyBannerMobile points={points} data-sentry-element="LoyaltyBannerMobile" data-sentry-source-file="LoyaltyBanner.tsx" />
      </Box>

      {/* Desktop View - Above tablet breakpoint */}
      <Box hideBelow="tablet" data-sentry-element="Box" data-sentry-source-file="LoyaltyBanner.tsx">
        <LoyaltyBannerDesktop points={points} memberSince={memberSince} data-sentry-element="LoyaltyBannerDesktop" data-sentry-source-file="LoyaltyBanner.tsx" />
      </Box>
    </>;
};